import {pathOr} from 'ramda';

import {store} from '../store';

const getLocal = () => {
  return pathOr('de', ['user', 'profile', 'language'], store.getState());
};

export default getLocal;
